import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13.592,
	height: 13.592,
	viewBox: "0 0 13.592 13.592",
	fill: "",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "error_black_24dp",
		d: "M8.8,2a6.8,6.8,0,1,0,6.8,6.8A6.8,6.8,0,0,0,8.8,2Zm0,7.475a.682.682,0,0,1-.68-.68V6.078a.68.68,0,1,1,1.359,0V8.8A.682.682,0,0,1,8.8,9.475Zm.68,2.718H8.116V10.835H9.475Z",
		transform: "translate(-2 -2)"
	})
});
export { SvgWarningIcon as ReactComponent };
